import GetMoneySteps from '@/widgets/GetMoneySteps';
import ActionCall from '@/widgets/HomePage/ActionCall';
import Advantages from '@/widgets/HomePage/Advantages';
import Banner from '@/widgets/HomePage/Banner';
import Benefits from '@/widgets/HomePage/Benefits';
import SeoText from '@/widgets/HomePage/SeoText';

export const HomePage = () => {
  return (
    <div className="home-page">
      <Banner />
      <Benefits />
      <GetMoneySteps />
      <Advantages />
      <ActionCall />
      <SeoText />
    </div>
  );
};
